import * as React from 'react';

import { DropdownInput } from '../../../Shared/index';
import ItemDropdown from '../../components/general_components/dropdown_selectors/item_dropdown';
import { packTypeOptionGroups } from '../../helpers/unitTemplates';

const ALL_DIAGNOSTICS = 'All Diagnostics'

const ARCHIVED_FLAG = 'Archived'
const SEARCH_BY_ACTIVITY = 'search by activity';
const SEARCH_BY_ACTIVITY_PACK = 'search by activity pack';

const packTypeOptions = packTypeOptionGroups.map(group => ({
  label: '',
  options: group.map(packType => ({ label: packType, value: packType }))
}));
const flatPackTypeOptions = packTypeOptions.flatMap(group => group.options);

export const UnitTemplateFilterInputs = ({
  handleRadioChange,
  searchByActivityPack,
  searchInput,
  handleSearch,
  switchFlag,
  flag,
  options,
  diagnostics,
  diagnostic,
  switchDiagnostic,
  packType,
  switchPackType
}) => {

  function handlePackTypeChange(option) {
    switchPackType(option.value)
  }

  function packTypeDropdown() {
    const selectedOption = flatPackTypeOptions.find(option => option.value === packType)
    return (
      <DropdownInput
        ariaLabel="Filter by pack type"
        className="select-item-dropdown pack-type-dropdown focus-on-light"
        handleChange={handlePackTypeChange}
        options={packTypeOptions}
        value={selectedOption}
      />
    )
  }

  function diagnosticsDropdown() {
    let diagnosticNames = diagnostics.filter(d => d.data && d.data["flag"] !== ARCHIVED_FLAG.toLowerCase()).map((d) => d.name)
    diagnosticNames.push(ALL_DIAGNOSTICS)
    return (
      <ItemDropdown
        callback={switchDiagnostic}
        items={diagnosticNames}
        selectedItem={diagnostic}
      />
    )
  }

  return(
    <div className="upper-section">
      <div className="activity-or-pack-search-container">
        <div className="radio-options">
          <div className="radio">
            <label htmlFor={SEARCH_BY_ACTIVITY}>
              <input aria-label={SEARCH_BY_ACTIVITY} checked={!searchByActivityPack} id={SEARCH_BY_ACTIVITY} onChange={handleRadioChange} type="radio" value={SEARCH_BY_ACTIVITY} />
              {SEARCH_BY_ACTIVITY}
            </label>
          </div>
          <div className="radio">
            <label htmlFor={SEARCH_BY_ACTIVITY_PACK}>
              <input aria-label={SEARCH_BY_ACTIVITY_PACK} checked={searchByActivityPack} id={SEARCH_BY_ACTIVITY_PACK} onChange={handleRadioChange} type="radio" value={SEARCH_BY_ACTIVITY_PACK} />
              {SEARCH_BY_ACTIVITY_PACK}
            </label>
          </div>
        </div>
      </div>
      {searchByActivityPack && <input
        aria-label="Search by activity pack"
        className="search-box"
        name="searchInput"
        onChange={handleSearch}
        placeholder="Search by activity pack"
        value={searchInput}
      />}
      {!searchByActivityPack && <input
        aria-label="Search by activity"
        className="search-box"
        name="searchInput"
        onChange={handleSearch}
        placeholder="Search by activity"
        value={searchInput}
      />}
      {packTypeDropdown()}
      <ItemDropdown
        callback={switchFlag}
        items={options}
        selectedItem={flag}
      />
      {diagnosticsDropdown()}
      <a className='new-unit-template-button quill-button contained green small focus-on-light' href={`${window.postbuildEnv.DEFAULT_URL}/cms/unit_templates/new`} rel="noopener noreferrer" target="_blank">New</a>
    </div>
  )
}

export default UnitTemplateFilterInputs;
